// import socket from '@/core/services/socket';
import { COMMIT_FETCH_CONTACTS, LISTENER_ACTIVE_USERS } from '@/store/enums/mutations-types'
import ApiService from "@/core/services/ApiService";

const module = {
  namespaced: true,
  state() {
    return {
      contacts: {},
    }
  },
  getters: {
    
    getContacts: (state, getters, rootState, rootGetters) => (search) => {
    
      return Object.keys(state.contacts).map((key) => {
        return {
          letter: key,
          contacts: state.contacts[key].filter(
            contact => contact.name
              .toLowerCase()
              .includes(search.toLowerCase())
          )
        }
      })
    }
  },
  mutations: {
    [COMMIT_FETCH_CONTACTS](state, payload){
      state.contacts = payload
    },
    [LISTENER_ACTIVE_USERS](state, payload){
      Object.keys(state.contacts).forEach((key) => {
        state.contacts[key].forEach((contact) => {
          const user = payload.find((user) => user.user_id == contact.id)
          if(user){
            state.contacts[key].forEach((contac) => {
              if(contac.id == user.user_id){
                contac.online = user.online
              }
            })
          }
        })
      })
    }
  },
  actions: {
    async fetchContacts({commit, state, rootState}, payload = null){
      
      const { data } = await ApiService.get(`/chat/users`)
      try {
        commit(COMMIT_FETCH_CONTACTS, data.data)
        // socket.emit('message', {
        //   type: 'general',
        //   channel: 'userStatus', // Reemplaza '1' con el ID del canal adecuado
        //   data: {check: true}
        // });
      } catch (error) {
        console.log('🚀 ~ fetchMessages ~ error', error)
      }
    }
  }
}

export default module